/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
// Locale configs
export const LOCALE_US = 'en-US';

export const LOCALE_MX = 'es-MX';

export const LOCALE_BR = 'pt-BR';

export const LOCALE_DOMAINS = {
  [LOCALE_US]: 'https://www.autozone.com',
  [LOCALE_MX]: 'https://www.autozone.com.mx',
  [LOCALE_BR]: 'https://www.autozone.com.br',
} as const;

export const DEFAULT_GATEWAY_URL = 'https://internal-st.nonprod.gcp-int.autozone.com';

export const DEFAULT_PUBLIC_GATEWAY_URL = 'https://external-st-api.autozone.com';
